import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useEffectOnce, useToggle } from 'react-use';

import useGettingDevices from './useGettingDevices';
import useDeviceDelete from './useDeviceDelete';
import useCreateDevice from './useCreateDevice';
import useDeviceEdit from './useDeviceEdit';
import useDeactivateDevice from './useDeactivateDevice';
import useGettingScreenShot from './useGettingScreenshot';
import useGettingLogs from './useGettingLogs';
import useDevicesFilter from './useDevicesFilter';
import { makeFetchEntityByIdSelector } from '../../../selectors/fetch';
import useGettingDevice from './useGettingDevice';

const useDevicesPageLogic = () => {
  const [pin, setPin] = useState(null);
  const [showForm, toggle] = useToggle(false);
  const { response: calendars } = useSelector(
    makeFetchEntityByIdSelector('calendars')
  );
  const { devices, onFetchDevices } = useGettingDevices();
  const { device, onFetchDevice, loading: deviceLoading } = useGettingDevice();
  const { createLoading, onCreate } = useCreateDevice({
    onFetchDevices,
  });
  const { onDeleteDevice } = useDeviceDelete({ onFetchDevices });
  const { onEdit } = useDeviceEdit({ calendars, onSuccess: onFetchDevices });
  const { onDeactivate } = useDeactivateDevice({
    onSuccess: () => {
      if (showForm) toggle();
      onFetchDevices();
    },
  });

  const {
    deviceScreenshot,
    onGetScreenshot,
    onFetchScreenshot,
  } = useGettingScreenShot();
  const { logs, onLogsRequest, onFetchLogs } = useGettingLogs();

  const {
    filters,
    sort,
    filter,
    onFilter,
    onSearch,
    onSort,
    sortDevices,
  } = useDevicesFilter();

  useEffectOnce(() => {
    onFetchDevices();
  });

  return {
    sort,
    filters,
    pin,
    setPin,
    logs,
    device,
    createLoading,
    showForm,
    toggle,
    calendars,
    devices: sortDevices(filter(devices)),
    deviceScreenshot,
    loading: deviceLoading,
    onCreate,
    onLogsRequest,
    onFetchLogs,
    onDeleteDevice,
    onEdit,
    onDeactivate,
    onGetScreenshot,
    onFetchDevice,
    onFilter,
    onSearch,
    onFetchScreenshot,
    onSort,
  };
};

export default useDevicesPageLogic;
